export const heroSubcategory = () => {
  if (document.querySelector('.hero-subcategory')) {
    window.lenis = lenis;
    document.querySelector('.hero-subcategory .button')?.addEventListener('click', () => {
      const scrollAmount = window.innerHeight;
      lenis.scrollTo(window.scrollY + scrollAmount, {
        duration: 1, // або інше значення, якщо хочеш повільніше/швидше
        easing: (t) => 1 - Math.pow(1 - t, 3), // кастомне згладжування, опціонально
      });
    });
  }
}